
<template>
  <div>
    <router-link to="/peapp/public/multipage/comp2">comp2</router-link>
    <h2>multicomp 1</h2>
    <h2>{{ statusMultipage }}</h2>
    <button @click="mutateStatus('dit is een status verandering')">dit is een status verandering</button>
  </div>
</template>


<script>
import { mapGetters, mapMutations } from 'vuex'
//, mapMutations
export default {
  name: 'multicomp1',

  components: {},

  props: {},
  data: function () {
    return {}
  },
  mounted: function () {},
  methods: {
    ...mapMutations('multipage', ['mutateStatus']),
  },
  computed: {
    ...mapGetters('multipage', ['statusMultipage']),
  },
}
</script>
